import RSAA from "redux-api-middleware/es/RSAA";
import {actions, defaultHeaders, types} from "../../../common/js/crud-actions";

export const search_types = {
    EMPLOYEES_SEARCH: 'EMPLOYEES_SEARCH',
    EMPLOYEES_SEARCH_SUCCESS: 'EMPLOYEES_SEARCH_SUCCESS',
    EMPLOYEES_SEARCH_ERROR: 'EMPLOYEES_SEARCH_ERROR'
};

const namespace = 'api/v1';

export const destroyCandidateAccount = (id) => {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/employees/${id}/destroy_candidate`,
            method: 'DELETE',
            headers: defaultHeaders,
            types: [
                { type: actions.resourceAction('EMPLOYEE', types.ACTION_DESTROY), meta: { id: id } },
                { type: actions.resourceActionSuccess('EMPLOYEE', types.ACTION_DESTROY), meta: { id: id } },
                { type: actions.resourceActionError('EMPLOYEE', types.ACTION_DESTROY), meta: { id: id } }
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
};

export const destroyNewEmployeeAccount = (id) => {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/employees/${id}/destroy_new_employee`,
            method: 'DELETE',
            headers: defaultHeaders,
            types: [
                { type: actions.resourceAction('EMPLOYEE', types.ACTION_DESTROY), meta: { id: id } },
                { type: actions.resourceActionSuccess('EMPLOYEE', types.ACTION_DESTROY), meta: { id: id } },
                { type: actions.resourceActionError('EMPLOYEE', types.ACTION_DESTROY), meta: { id: id } }
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
};

export const searchEmployee = (id_or_name, id = false) => {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/employees/search`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                search_types.EMPLOYEES_SEARCH,
                search_types.EMPLOYEES_SEARCH_SUCCESS,
                search_types.EMPLOYEES_SEARCH_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify({ value: id_or_name, id: id })
        },
        auth: true
    };
};
